export const MaxCellSize = 60
export const Rows = 8
export const Cols = 6
export const ObstacleCount = 6

export const CardPairsProportion = 0.5
export const GameTotalTime = 60
export const ScorePerMatch= 10